import { ICategory } from '@server/data/models/category';
import { useCategoryDetailQuery } from 'src/generated/graphql';
import { fromJS, Record } from 'immutable';

const useCategory = (id: any) => {
  const { loading, error, data } = useCategoryDetailQuery({
    variables: { id },
    fetchPolicy: 'cache-first',
  });

  const category = !!data ? ((data?.category as unknown) as ICategory) : {};

  return { loading, error, category };
};

export default useCategory;
